import PropTypes from 'prop-types';

export default {
    onResize: PropTypes.func,
    onTableChange: PropTypes.func,
    onTableScroll: PropTypes.func,
    onScrollbarScroll: PropTypes.func,
    setTableView: PropTypes.func,
    setScrollbarVisibility: PropTypes.func,
};
